var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "organisation-information", attrs: { role: "main" } },
    [
      _c(
        "div",
        { staticClass: "required-fields-info-organisation-information" },
        [
          _c("i", { staticClass: "fas fa-asterisk icon red" }),
          _vm._v(" " + _vm._s(_vm.$t("RequiredFieldsInfo")))
        ]
      ),
      _vm._v(" "),
      _c("h1", { attrs: { tabindex: "-1" } }, [
        _vm._v(_vm._s(_vm.$t("Organisation.Title")))
      ]),
      _vm._v(" "),
      _c("ValidationObserver", {
        ref: "organisationObserver",
        attrs: { slim: "" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var invalid = ref.invalid
              var validate = ref.validate
              return [
                !_vm.loading || _vm.validateForm(!invalid)
                  ? _c(
                      "form",
                      {
                        staticClass: "mb-5",
                        attrs: { id: "organisationForm" },
                        on: {
                          submit: function($event) {
                            $event.preventDefault()
                            return _vm.save()
                          }
                        }
                      },
                      [
                        _c("business-id-row", {
                          attrs: {
                            title: "Organisation.BusinessId",
                            isReadOnly: !_vm.hasProcuration,
                            required: true
                          },
                          model: {
                            value: _vm.organisation.businessId,
                            callback: function($$v) {
                              _vm.$set(_vm.organisation, "businessId", $$v)
                            },
                            expression: "organisation.businessId"
                          }
                        }),
                        _vm._v(" "),
                        _c("text-input-row", {
                          attrs: {
                            title: "Organisation.Address",
                            id: "organisation_address",
                            required: true,
                            maxLength: 100
                          },
                          model: {
                            value: _vm.organisation.address,
                            callback: function($$v) {
                              _vm.$set(_vm.organisation, "address", $$v)
                            },
                            expression: "organisation.address"
                          }
                        }),
                        _vm._v(" "),
                        _c("text-input-row", {
                          attrs: {
                            title: "Organisation.PostalCode",
                            id: "organisation_postalcode",
                            required: true,
                            maxLength: 5,
                            rules: _vm.postalCodeRules
                          },
                          model: {
                            value: _vm.organisation.postalCode,
                            callback: function($$v) {
                              _vm.$set(_vm.organisation, "postalCode", $$v)
                            },
                            expression: "organisation.postalCode"
                          }
                        }),
                        _vm._v(" "),
                        _c("text-input-row", {
                          attrs: {
                            title: "Organisation.City",
                            id: "organisation_city",
                            required: true,
                            maxLength: 100
                          },
                          model: {
                            value: _vm.organisation.city,
                            callback: function($$v) {
                              _vm.$set(_vm.organisation, "city", $$v)
                            },
                            expression: "organisation.city"
                          }
                        }),
                        _vm._v(" "),
                        _c("text-input-row", {
                          attrs: {
                            title: "Organisation.Phone",
                            id: "organisation_phone",
                            required: true,
                            maxLength: 16,
                            rules: _vm.phoneRules
                          },
                          model: {
                            value: _vm.organisation.phone,
                            callback: function($$v) {
                              _vm.$set(_vm.organisation, "phone", $$v)
                            },
                            expression: "organisation.phone"
                          }
                        }),
                        _vm._v(" "),
                        _c("text-input-row", {
                          attrs: {
                            title: "Organisation.Email",
                            id: "organisation_email",
                            required: true,
                            maxLength: _vm.emailMaxLength,
                            rules: _vm.emailRules
                          },
                          model: {
                            value: _vm.organisation.email,
                            callback: function($$v) {
                              _vm.$set(_vm.organisation, "email", $$v)
                            },
                            expression: "organisation.email"
                          }
                        }),
                        _vm._v(" "),
                        _c("text-input-row", {
                          attrs: {
                            title: "Organisation.WebAddress",
                            id: "organisation_webaddress",
                            required: false,
                            maxLength: 100
                          },
                          model: {
                            value: _vm.organisation.webAddress,
                            callback: function($$v) {
                              _vm.$set(_vm.organisation, "webAddress", $$v)
                            },
                            expression: "organisation.webAddress"
                          }
                        }),
                        _vm._v(" "),
                        _c("radio-button-option-row", {
                          attrs: {
                            title: "Organisation.Language.Title",
                            instructionsKey:
                              "Organisation.Language.Title_Instructions",
                            labelColWidth: "col-12 col-md-4 col-lg-3",
                            required: true,
                            disabled: !_vm.hasProcuration,
                            options: _vm.languageOptions
                          },
                          model: {
                            value: _vm.organisationLanguage,
                            callback: function($$v) {
                              _vm.organisationLanguage = $$v
                            },
                            expression: "organisationLanguage"
                          }
                        }),
                        _vm._v(" "),
                        _c("radio-button-row", {
                          attrs: {
                            title: "Organisation.HasConvictionOrSanction",
                            instructionsKey:
                              "Organisation.HasConvictionOrSanction_Instructions",
                            labelColWidth: "col-12 col-md-4 col-lg-3",
                            required: true,
                            disabled: !_vm.hasProcuration
                          },
                          model: {
                            value: _vm.organisation.hasConvictionOrSanction,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.organisation,
                                "hasConvictionOrSanction",
                                $$v
                              )
                            },
                            expression: "organisation.hasConvictionOrSanction"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "mt-5 mb-5 row form-group" }, [
                          _c("h2", { staticClass: "col-12 col-md-3" }, [
                            _vm._v(
                              _vm._s(_vm.$t("Organisation.Contacts.Title"))
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-12 col-md-9" },
                            [
                              _vm.organisation.chairmanOfTheBoard
                                ? _c("organisation-contact-control", {
                                    staticClass: "mb-3",
                                    attrs: {
                                      title:
                                        "Organisation.Contacts.ChairmanOfTheBoard",
                                      item: _vm.organisation.chairmanOfTheBoard,
                                      required: true
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.organisation.executiveDirector
                                ? _c("organisation-contact-control", {
                                    staticClass: "mb-3",
                                    attrs: {
                                      title:
                                        "Organisation.Contacts.ExecutiveDirector",
                                      item: _vm.organisation.executiveDirector,
                                      required: true
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.organisation.financialResponsible
                                ? _c("organisation-contact-control", {
                                    staticClass: "mb-3",
                                    attrs: {
                                      title:
                                        "Organisation.Contacts.FinancialResponsible",
                                      item:
                                        _vm.organisation.financialResponsible,
                                      required: true
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.organisation.communicationsResponsible
                                ? _c("organisation-contact-control", {
                                    attrs: {
                                      title:
                                        "Organisation.Contacts.CommunicationsResponsible",
                                      item:
                                        _vm.organisation
                                          .communicationsResponsible,
                                      required: false
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row form-group" }, [
                          _c("h2", { staticClass: "col-12 col-md-3" }, [
                            _vm._v(_vm._s(_vm.$t("Attachment.Attachments")))
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-12 col-md-9" },
                            [
                              !_vm.hasNeverUpdatedAttachments
                                ? _c("check-box-control", {
                                    attrs: {
                                      id: "organisation_attachmentsaresame",
                                      title: "Organisation.AttachmentsAreSame",
                                      toolTipKeyQuestion:
                                        "Organisation.AttachmentsAreSameToolTip"
                                    },
                                    model: {
                                      value:
                                        _vm.organisation.attachmentsAreSame,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.organisation,
                                          "attachmentsAreSame",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "organisation.attachmentsAreSame"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.organisation.attachmentsUpdatedDate
                                ? _c(
                                    "span",
                                    { staticClass: "attachment-last-updated" },
                                    [
                                      _c("i", [
                                        _vm._v(
                                          _vm._s(_vm.attachmentsLastUpdatedText)
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.organisation.attachmentsAreSame
                                ? _c("attachments", {
                                    attrs: { attachments: _vm.attachments }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "mb-5 d-block d-md-none" }),
                        _vm._v(" "),
                        _vm.isNewApplicationSituation
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-secondary",
                                attrs: {
                                  type: "button",
                                  disabled: _vm.isSendBtnDisabled(!invalid),
                                  "aria-disabled": _vm.isSendBtnDisabled(
                                    !invalid
                                  )
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.saveAndStartApplication()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n        " +
                                    _vm._s(
                                      _vm.$t(
                                        "Organisation.Btn_SaveAndStartApplication"
                                      )
                                    ) +
                                    "\n        "
                                ),
                                _c("i", { staticClass: "fas fa-chevron-right" })
                              ]
                            )
                          : _c(
                              "button",
                              {
                                staticClass: "btn btn-secondary",
                                attrs: {
                                  type: "button",
                                  disabled: _vm.isSendBtnDisabled(!invalid),
                                  "aria-disabled": _vm.isSendBtnDisabled(
                                    !invalid
                                  )
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.save()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n        " +
                                    _vm._s(_vm.$t("Save.Save")) +
                                    "\n        "
                                ),
                                _c("i", { staticClass: "fas fa-chevron-right" })
                              ]
                            ),
                        _vm._v(" "),
                        _vm.contacts && _vm.contacts.length > 0
                          ? _c(
                              "div",
                              { staticClass: "mt-5 mb-5 row form-group" },
                              [
                                _c("h2", { staticClass: "col-12 col-md-3" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("Organisation.SteaContacts.Title")
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-12 col-md-9" },
                                  [
                                    _c("stea-contact-control", {
                                      attrs: { contacts: _vm.contacts }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }